/**
 * This file contains head tags that are common through all Domain Group websites.
 */

/**
 * DNS names to prefetch (only put common ones here across all pages)
 * Avoid adding analytics and ads scripts here as they vary greatly across pages
 */
const dnsPrefetchDomains = [
  '//s.domainstatic.com.au',
  '//rimh2.domainstatic.com.au',
];

/**
 * DNS prefetch tag opject
 */
const dnsPrefetchTags = dnsPrefetchDomains.map(domainName => ({
  tagName: 'link',
  props: {
    rel: 'dns-prefetch',
    href: domainName,
  },
}));

/**
 * These are common meta tags that should appear in every page of domain.com.au
 * @type {Array}
 */
const commonHeadTagList = [
  {
    tagName: 'meta',
    props: {
      charSet: 'utf-8',
    },
  },
  {
    tagName: 'meta',
    props: {
      httpEquiv: 'content-language',
      content: 'en-au',
    },
  },
  {
    tagName: 'meta',
    props: {
      name: 'format-detection',
      content: 'telephone=no',
    },
  },
  {
    tagName: 'meta',
    props: {
      httpEquiv: 'X-UA-Compatible',
      content: 'IE=edge',
    },
  },
  {
    tagName: 'meta',
    props: {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1',
    },
  },
];

module.exports = commonHeadTagList.concat(dnsPrefetchTags);
